/**
 * Deferred init of flip clocks, and any other needed updates.
 *
 * @module
 */

class FlipClock {
    /**
     * Call flip clock init functions
     *
     * @return {void}
     */
    static init() {
        Object.keys(window)
            .filter(globalVarName => globalVarName.indexOf('initFlipClock_') === 0)
            .forEach(initFn => window[initFn].call(window));
    }
}

/**
 * Initialize JS pagination component for each .pagination element in the document.
 *
 * @return {void}
 */
export function init() {
    FlipClock.init();
}
